export default __webpack_public_path__ + "static/media/logo-unilab.2e9fe079.png";